import { useEffect } from 'react'

import API from '@/utils/api'
import sleep from '@/Xmerald-UI/utilities/sleep'
import history from '@/routes/history'

import {
  shouldSkipCloseSessionsRedirect,
  validateUserSessions,
} from '@/utils/session'

export function useActiveSessionsGuard (isAuth) {
  // SPA navigations (React Router <Link> / history.push)
  useEffect(() => {
    if (!isAuth) return undefined

    const unlisten = history.listen((location) => {
      if (shouldSkipCloseSessionsRedirect(location.pathname)) return
      validateUserSessions()
    })

    return unlisten
  }, [isAuth])

  // Socket: another session signed in / forced sign-out signal
  useEffect(() => {
    const noop = () => {}

    API.subscribeSocketLiveLobby(noop, noop, noop, noop, async () => {
      if (!isAuth) return

      await sleep(2000)
      validateUserSessions()
    })

    return () => API.unSubscribeSocketLobby()
  }, [isAuth])
}
